/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit VerticalTimeline/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import VerticalTimelineForm from './VerticalTimelineForm/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function VerticalTimeline({
  children,
  viewPath = "/DesignSystem/VerticalTimeline",
  closePopover
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let timelineHistoryValueData = fromData.useDataValue({ viewPath,
context: 'timeline',
path: 'history',
})
  return (<React.Fragment
>
<div
  data-testid="VerticalTimeline.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 text="History"
 weight="medium"
 marginBottom={dtSpaceXxs}
/>
<div
  data-testid="VerticalTimeline.Vertical:1"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<div
  data-testid="VerticalTimeline.List"
  data-view-path={viewPath}
 style={{'--g-1-1l82wH': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.List}`}
>
{Array.isArray(timelineHistoryValueData) && timelineHistoryValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="timeline_event"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/VerticalTimelineForm(${item?.id ?? item?._id ?? index})`}
      >
<VerticalTimelineForm
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/VerticalTimelineForm(${item?.id ?? item?._id ?? index})`}
 closePopover={closePopover}
/>
</ListItem>
)}
</div>
</div>
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }